import { render, staticRenderFns } from "./b_WizardBuyerRoot.vue?vue&type=template&id=16a1e398&scoped=true&"
import script from "./b_WizardBuyerRoot.vue?vue&type=script&lang=js&"
export * from "./b_WizardBuyerRoot.vue?vue&type=script&lang=js&"
import style0 from "./b_WizardBuyerRoot.vue?vue&type=style&index=0&id=16a1e398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1e398",
  null
  
)

export default component.exports